import { Component, OnInit, Renderer2 } from '@angular/core';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent implements OnInit {

  darkMode = false;

  constructor(private renderer: Renderer2) {
    let theme = localStorage.getItem('theme');
    if (theme && localStorage.getItem('theme') === 'dark') {
      this.darkMode = true;
    }
    this.setTheme();
  }

  ngOnInit() {}

  onToggleTheme() {
    this.darkMode = !this.darkMode;
    this.setTheme();
  }

  setTheme() {
    if(this.darkMode) {
      document.body.setAttribute('data-theme', 'dark');
      localStorage.setItem('theme', 'dark');
    } else {
      document.body.setAttribute('data-theme', 'light');
      localStorage.setItem('theme', 'light');
    }
  }

}
